import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import ElapsedTime from '../../components/ElapsedTime';
import { GenerateThink5whysCode } from '../../components/GenerateThink5whysCode';
import "../../styles/Think5WhysCode.css";

const MyThink5WhysCode = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/my-profile-home");
  };

  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "Invalid Date";
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  const testCode = GenerateThink5whysCode(); 

  return (
    <div className='bg-black'>
      <div className="border-b border-blue-400 py-4 px-4 w-full text-left">
        <h2 className="text-xl lg:text-2xl text-yellow-200">Think5Whys User Code</h2>
      </div>
      <div className="min-h-[90vh] border-b border-blue-400 flex flex-col items-center">
        <div className="flex flex-col justify-center items-center mt-20 border border-blue-400 max-w-5xl p-8 text-center space-y-3">
          <p><strong>Name:</strong> {authState.user.name}</p>
          <p><strong>Email:</strong> {authState.user.email}</p>
          <p><strong>Registration Date:</strong> {formatDate(new Date(authState.user.createdAt))}</p>
          <ElapsedTime startTime={new Date(authState.user.createdAt)} />
          <p className="profile-highlight"><strong>Think5Whys Code:</strong> {authState.user.think5whyscode || "N/A"}</p>
          <button className="cancel-button mx-auto" onClick={handleClose}>Close</button>
        </div>

      </div>

      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-2">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm lg:text-m text-yellow-200">
            (c) 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-[#005C5C]">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-[#005C5C]">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-[#005C5C]">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-[#005C5C]">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>

  );
};

export default MyThink5WhysCode;
